import { PATH } from "utils/constants";

const navList = [
  { path: PATH.dashboard, content: "대시보드" },
  { path: PATH.statistics, content: "통계" },
];

export { navList };
